import React, { useState } from "react";
import { motion } from "framer-motion";
import { Reveal, stagger, fadeUp } from "./Reveal";
import { Star, MessageCircle } from "lucide-react";
import { REVIEWS, SITE } from "../data/site";

const TOPICS = ["All", "ADHD", "Decision Making", "Emotional Healing", "Relationship Clarity"];

export const Testimonials = () => {
  const [topic, setTopic] = useState("All");
  const list = topic === "All" ? REVIEWS : REVIEWS.filter((r) => r.topic === topic);

  return (
    <section id="reviews" className="py-24 sm:py-32 bg-[#3A7D32] text-[#F2F8E8] relative overflow-hidden">
      <div className="pointer-events-none absolute top-0 right-0 w-96 h-96 rounded-full bg-[#FFC9A0]/10 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12">
          <div>
            <Reveal><span className="overline text-[#FFC9A0]">05 — In their own words</span></Reveal>
            <Reveal delay={0.05}>
              <h2 className="section-title text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight">
                A perfect <span className="text-[#F7EBC6]">5.0</span> from every client
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <div className="flex items-center gap-3">
              <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} size={20} className="fill-[#E5A93C] text-[#E5A93C]" />)}</div>
              <span className="text-sm text-[#C9DFAC]">Verified Google reviews</span>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="flex flex-wrap gap-2 mb-10">
            {TOPICS.map((t) => (
              <button key={t} data-testid={`reviews-filter-${t.toLowerCase().replace(/ /g, "-")}`} onClick={() => setTopic(t)}
                className={`rounded-full px-4 py-2 text-xs transition-all border ${topic === t ? "bg-[#FFC9A0] text-[#3A7D32] border-[#FFC9A0]" : "text-[#C9DFAC] border-white/20 hover:border-[#FFC9A0]"}`}>
                {t}
              </button>
            ))}
          </div>
        </Reveal>

        <motion.div variants={stagger} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-60px" }}
          className="grid md:grid-cols-2 gap-5">
          {list.map((r, i) => (
            <motion.div key={i} variants={fadeUp} data-testid={`review-card-${i}`}
              className="rounded-3xl bg-[#F2F8E8] text-[#20301A] p-7 soft-shadow">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="grid place-items-center w-11 h-11 rounded-full bg-[#DFF0C4] font-serif text-lg text-[#3A7D32]">{r.name[0]}</div>
                  <div>
                    <div className="font-medium text-sm">{r.name}</div>
                    <div className="text-[0.7rem] text-[#55703F]">{r.meta}</div>
                  </div>
                </div>
                <div className="flex">{[...Array(5)].map((_, k) => <Star key={k} size={13} className="fill-[#E5A93C] text-[#E5A93C]" />)}</div>
              </div>
              <p className="mt-4 text-sm text-[#3C5A2E] leading-relaxed">"{r.text}"</p>
              <div className="mt-4 rounded-2xl bg-[#FFEFDF] border border-[#FFC9A0] p-4">
                <div className="flex items-center gap-2 text-[0.7rem] font-mono uppercase tracking-widest text-[#3A7D32] mb-1">
                  <MessageCircle size={12} /> Response from Dr. Pratyusha
                </div>
                <p className="text-sm text-[#55703F]">{r.reply}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
